<template>
    <div class="pcoded-main-container pb-5">
        <div v-if="tourActive" class="overlay"></div>

        <v-tour
            name="dashboardTour"
            :steps="steps"
            :options="tourOptions"
            :callbacks="tourCallbacks"
        >
            <template slot-scope="tour">
                <transition name="fade">
                    <v-step
                        v-if="tour.steps[tour.currentStep]"
                        :key="tour.currentStep"
                        :step="tour.steps[tour.currentStep]"
                        :previous-step="tour.previousStep"
                        :next-step="tour.nextStep"
                        :stop="tour.stop"
                        :skip="tour.skip"
                        :is-first="tour.isFirst"
                        :is-last="tour.isLast"
                        :labels="tour.labels"
                        :highlight="true"
                        class="step"
                        :class="{
                            'overlay-background': tour.currentStep === 0,
                        }"
                    >
                        <template v-if="tour.currentStep === 0">
                            <div
                                slot="actions"
                                style="display: flex; flex-direction: column"
                            >
                                <button
                                    @click="tour.nextStep"
                                    style="width: 100%"
                                    class="tour-btn btn-primary"
                                >
                                    {{ $t('dashboard.tour_start') }}
                                </button>
                                <button
                                    @click="
                                        tour.stop();
                                        markTourAsSeen();
                                    "
                                    style="
                                        width: fit-content;
                                        font-size: 0.8rem;
                                        margin: 0 auto;
                                        opacity: 70%;
                                    "
                                    class="tour-btn"
                                >
                                    {{ $t('dashboard.tour_stop') }}
                                </button>
                            </div>
                        </template>

                        <template v-if="tour.currentStep != 0">
                            <div
                                slot="actions"
                                style="display: flex; flex-direction: column"
                            >
                                <div
                                    style="
                                        display: flex;
                                        flex-direction: row;
                                        width: 100%;
                                        height: 100%;
                                        gap: 0.5rem;
                                    "
                                >
                                    <button
                                        v-if="tour.currentStep > 1"
                                        @click="
                                            tour.previousStep();
                                            openSidebar(
                                                tour.currentStep,
                                                'close'
                                            );
                                        "
                                        class="tour-btn btn-danger"
                                        style="font-size: 0.8rem; width: 100%"
                                    >
                                        {{ $t('dashboard.tour_back') }}
                                    </button>
                                    <button
                                        v-if="
                                            tour.currentStep != steps.length - 1
                                        "
                                        @click="
                                            tour.nextStep();
                                            openSidebar(
                                                tour.currentStep,
                                                'open'
                                            );
                                        "
                                        class="tour-btn btn-primary"
                                        style="font-size: 0.8rem; width: 100%"
                                    >
                                        {{ $t('dashboard.tour_next') }}
                                    </button>
                                    <button
                                        v-if="
                                            tour.currentStep == steps.length - 1
                                        "
                                        @click="
                                            tour.stop();
                                            markTourAsSeen();
                                        "
                                        class="tour-btn btn-primary"
                                        style="font-size: 0.8rem; width: 100%"
                                    >
                                        {{ $t('dashboard.tour_finish') }}
                                    </button>
                                </div>
                                <button
                                    v-if="tour.currentStep != steps.length - 1"
                                    @click="
                                        tour.stop();
                                        markTourAsSeen();
                                    "
                                    class="tour-btn"
                                    style="
                                        font-size: 0.8rem;
                                        width: fit-content;
                                        margin: 0 auto;
                                        opacity: 70%;
                                    "
                                >
                                    {{ $t('dashboard.tour_stop') }}
                                </button>
                            </div>
                        </template>
                    </v-step>
                </transition>
            </template>
        </v-tour>

        <div class="pcoded-wrapper">
            <title>{{ $t("dashboard.title") }} - DOFFERO®</title>
            <div class="pcoded-content">
                <under-bar-name
                    :title="$t('dashboard.text_0')"
                    :margin="true"
                    id="v-step-0"
                />
                <div class="margin">
                    <div class="row p-0">
                        <div class="col-lg-4 pl-2">
                            <div class="dash_box blue">
                                <div>
                                    <h3>
                                        {{
                                            formatPrice(
                                                statistic.price_by_month[5]
                                            )
                                        }}
                                        {{ $currency.symbol }}
                                    </h3>
                                    <p>{{ $t("dashboard.text_1") }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="dash_box orange">
                                <div>
                                    <h3>
                                        {{
                                            formatPrice(
                                                statistic.all_active_price
                                            )
                                        }}
                                        {{ $currency.symbol }}
                                    </h3>
                                    <p>{{ $t("dashboard.text_2") }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="dash_box yellow">
                                <div>
                                    <h3>
                                        {{
                                            formatNumber(
                                                statistic.klients_count
                                            )
                                        }}
                                    </h3>
                                    <p>{{ $t("dashboard.text_3") }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="graphs" id="v-step-1">
                        <div class="graph1">
                            <offers-value-graph
                                :data="statistic.price_by_month"
                                :title="true"
                            />
                        </div>
                        <div class="graph2">
                            <offers-count-graph
                                :data="statistic.count_by_month"
                            />
                        </div>
                    </div>
                    <div class="row pl-2 pt-0">
                        <div class="col-lg-12 p-0">
                            <h1 class="posledne_ponuky">
                                {{ $t("dashboard.text_21") }}
                            </h1>
                        </div>
                        <div class="col-lg-12 pt-0" style="position: relative">
                            <div
                                v-if="tourActive"
                                style="
                                    position: absolute;
                                    top: 5%;
                                    left: 0%;
                                    height: 14rem;
                                    width: 100%;
                                "
                                id="v-step-2"
                            ></div>
                            <offers-table
                                :user="user"
                                :dashboard="1"
                                :premium="premium"
                                :offers_count="offers_count"
                                :offers="offers"
                                :klients="klients"
                                :props_zdroj_kontaktu="props_zdroj_kontaktu"
                            />
                        </div>
                        <div v-if="offers.length > 1" class="all_offers">
                            <a href="/admin/offers" class="button">
                                {{ $t("dashboard.text_22") }}
                            </a>
                        </div>
                    </div>
                    <div v-if="offers.length < 1" class="row pl-2">
                        <div class="col-lg-12 p-0">
                            <div class="non_offer">
                                <b>{{ $t("dashboard.text_23") }}</b>
                                <a
                                    href="/admin/offers/create"
                                    class="create button"
                                >
                                    <svg class="mr-2" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="vertical-align: middle;"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                                    {{ $t("dashboard.text_24") }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UnderBarName from "../../layouts/Header/UnderBarName.vue";
import DashGraphLeft from "./DashGraphLeft.vue";
import DashGraphRight from "./DashGraphRight.vue";
import OffersTable from "../offer/OffersTable.vue";
import OffersValueGraph from "./OffersValueGraph.vue";
import OffersCountGraph from "./OffersCountGraph.vue";
import axios from "axios";
export default {
    name: "dashboard-tour",
    props: [
        "info",
        "premium",
        "is_admin",
        "user",
        "klients",
        "props_zdroj_kontaktu",
        "subscription_alert",
        "offer_count",
        "sub_user_subscription_alert",
    ],
    components: {
        OffersTable,
        UnderBarName,
        DashGraphLeft,
        DashGraphRight,
        OffersValueGraph,
        OffersCountGraph,
    },
    data() {
        return {
            datas: null,
            count: null,
            user_all: null,
            user_premium: null,
            user_free: null,
            statistic: null,
            offers_count: 0,
            mojafirma_count: null,
            polozky_ceny_count: null,
            offers: null,
            load_admin_stats: true,
            tourActive: null,

            tourCallbacks: {
                onStop: this.stopTour,
            },
        };
    },
    created() {
        this.statistic = this.info.statistic;
        this.offers_count = this.info.offers_count;
        this.offers = this.info.offers;
    },
    computed: {
        tourOptions() {
            return {
                useKeyboardNavigation: false,
                labels: {
                    buttonSkip: this.$t('dashboard.tour_skip'),
                    buttonPrevious: this.$t('dashboard.tour_back'),
                    buttonNext: this.$t('dashboard.tour_next'),
                    buttonStop: this.$t('dashboard.tour_finish'),
                },
            };
        },
        steps() {
            const h5 = (key) => `<h5 style="font-weight: bold; color: black;">${this.$t(key)}</h5>`;
            return [
                {
                    target: null,
                    content: `<div style="display: flex; flex-direction: column; width: 100%; gap: 1.5rem; align-items: center;"><img style="height 150px; width: 150px; border-radius: 5px;" src="/img/dashboard/dog.jpeg" /><span>${h5('dashboard.tour_s0_title')} ${this.$t('dashboard.tour_s0_text')}</span></div>`,
                    placement: "center",
                    position: { top: "50%", left: "60%", transform: "translate(-50%, -50%)", position: "absolute", zIndex: 9999 },
                },
                { target: "#v-step-1", content: `${h5('dashboard.tour_s1_title')} ${this.$t('dashboard.tour_s1_text')}` },
                { target: "#v-step-2", content: `${h5('dashboard.tour_s2_title')}${this.$t('dashboard.tour_s2_text')}` },
                { target: "#v-step-3", content: `${h5('dashboard.tour_s3_title')} ${this.$t('dashboard.tour_s3_text')}` },
                { target: "#v-step-stav", content: `${h5('dashboard.tour_s4_title')} ${this.$t('dashboard.tour_s4_text')}` },
                { target: "#v-step-4", content: `${h5('dashboard.tour_s5_title')} ${this.$t('dashboard.tour_s5_text')}` },
                { target: "#v-step-5", content: `${h5('dashboard.tour_s6_title')} ${this.$t('dashboard.tour_s6_text')}` },
                { target: "#v-step-6", content: `${h5('dashboard.tour_s7_title')} ${this.$t('dashboard.tour_s7_text')}` },
                { target: "#v-step-7", content: `${h5('dashboard.tour_s8_title')} ${this.$t('dashboard.tour_s8_text')}`, params: { placement: "right" } },
                { target: "#v-step-8", content: `<div style="display:flex;flex-direction:column;width:100%;gap:1.5rem;"><span>${h5('dashboard.tour_s9a_title')} ${this.$t('dashboard.tour_s9a_text')}</span><span>${h5('dashboard.tour_s9b_title')} ${this.$t('dashboard.tour_s9b_text')}</span><span>${h5('dashboard.tour_s9c_title')} ${this.$t('dashboard.tour_s9c_text')}</span></div>`, params: { placement: "right" } },
                { target: "#v-step-9", content: `<div style="display:flex;flex-direction:column;width:100%;gap:1.5rem;"><span>${h5('dashboard.tour_s10a_title')} ${this.$t('dashboard.tour_s10a_text')}</span><span>${h5('dashboard.tour_s10b_title')} ${this.$t('dashboard.tour_s10b_text')}</span></div>`, params: { placement: "right" } },
                { target: "#v-step-10", content: `<div style="display:flex;flex-direction:column;width:100%;gap:1.5rem;"><span>${h5('dashboard.tour_s11a_title')} ${this.$t('dashboard.tour_s11a_text')}</span><span>${h5('dashboard.tour_s11b_title')} ${this.$t('dashboard.tour_s11b_text')}</span></div>`, params: { placement: "right" } },
            ];
        },
    },
    methods: {
        formatPrice(value) {
            let val = (value / 1).toFixed(2).replace(".", ",");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        formatNumber(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        openSidebar(stepId, action) {
            if (stepId === 6 && action === "open") {
                const element = document.getElementById("menu-left-mobile");
                if (element) {
                    element.classList.remove("hide");
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                }
            }

            if (stepId === 7 && action === "close") {
                const element = document.getElementById("menu-left-mobile");
                if (element) {
                    element.classList.add("hide");
                }
            }
        },
        updateOverlay() {
            const step = this.steps[this.$tours["dashboardTour"].currentStep];

            if (!step || !step.target) {
                return;
            }

            const target = document.querySelector(step.target);

            if (!target) {
                return;
            }

            const rect = target.getBoundingClientRect();

            const windowWidth = window.innerWidth;

            const scrollTop =
                window.scrollY || document.documentElement.scrollTop;
            const scrollLeft =
                window.scrollX || document.documentElement.scrollLeft;

            const overlayElement = document.querySelector(".overlay");

            overlayElement.style.width = `${rect.width + 30}px`;
            overlayElement.style.height = `${rect.height + 20}px`;

            if (windowWidth > 1100) {
                const topPosition = rect.top + scrollTop - 100;
                overlayElement.style.top = `${topPosition}px`;
            } else if (windowWidth < 1100) {
                const topPosition = rect.top + scrollTop - 70;
                overlayElement.style.top = `${topPosition}px`;
            }

            if (window.innerWidth < 630) {
            }

            const leftPosition = rect.left + scrollLeft - 15;
            overlayElement.style.left = `${leftPosition}px`;

            overlayElement.style.display = "block";

            setTimeout(() => {
                this.updateOverlay();
            }, 200);
        },
        adjustPlacementForSmallScreens() {
            if (window.innerWidth < 630) {
                this.steps.forEach((step) => {
                    if (step.params && step.params.placement) {
                        step.params.placement = "bottom";
                    }
                });
            }
        },
        async markTourAsSeen() {
            try {
                await axios.post("/api/user/update-seen-tour");
            } catch (error) {
                console.error("Error updating seen tour status", error);
            }
        },
        stopTour() {
            this.tourActive = false;
        },
    },
    mounted() {
        if (this.user.seen_tour == 0) {
            this.$tours["dashboardTour"].start();
            this.tourActive = true;
        }

        if (this.tourActive) {
            this.$watch("$tours.dashboardTour.currentStep", () => {
                this.$nextTick(() => {
                    this.updateOverlay();
                });
            });

            window.addEventListener("resize", this.updateOverlay);
            window.addEventListener("scroll", this.updateOverlay);
            window.addEventListener(
                "resize",
                this.adjustPlacementForSmallScreens
            );
        }
    },
    beforeDestroy() {
        if (this.tourActive) {
            window.removeEventListener("resize", this.updateOverlay);
            window.removeEventListener("scroll", this.updateOverlay);
            window.removeEventListener(
                "resize",
                this.adjustPlacementForSmallScreens
            );
        }
    },
};
</script>
<style lang="scss" scoped>
.margin {
    margin: 30px 35px 15px;
    @media (max-width: 600px) {
        margin: 16px 10px 15px;
    }
}
.graphs {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 30px;
    @media (max-width: 800px) {
        flex-direction: column;
    }
    .graph1,
    .graph2 {
        width: 48%;
        @media (max-width: 800px) {
            width: 98%;
        }
    }
}

.non_offer {
    align-items: center;
    display: flex;
    padding-bottom: 0 !important;
    height: 140px;
    display: grid;
    text-align: center;
    .create {
        margin: 20px auto;
    }
}
.all_offers {
    width: 100%;
    height: 104px;
    position: absolute;
    bottom: 36px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    background: linear-gradient(0deg, #f9f9f9 0%, rgba(249, 249, 249, 0) 100%);
    a.button {
        position: absolute;
        left: 0;
        right: 0;
        bottom: -20px;
        margin: auto;
        width: 219px;
        height: 44px;
        background: #3455db;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        color: #ffffff;
    }
}
.posledne_ponuky {
    margin-top: 30px;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: #212541;
}
.pcoded-content {
    .row {
        padding: 20px;
    }
}
@media (max-width: 600px) {
    .uzivatelia_mob {
        display: block !important;
    }
}
.dash_box {
    width: 100%;
    height: 87px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding: 21px 17px;
    &.blue {
        background: #212541;
    }

    &.orange {
        background: #f93c34;
        p {
            opacity: 0.8;
        }
    }
    &.yellow {
        background: #fbbf24;
        p {
            opacity: 0.8;
        }
    }
    div {
        font-family: Montserrat;
        font-style: normal;
        h3 {
            font-weight: 600;
            font-size: 20px;
            line-height: 110%;
            color: #ffffff;
            margin-bottom: 7px;
        }
        p {
            font-weight: 600;
            font-size: 10px;
            line-height: 12px;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: #ffffff;
            opacity: 0.6;
            margin: 0;
        }
    }
}
a.button {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -20px;
    margin: auto;
    width: 219px;
    height: 44px;
    background: #3455db;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #ffffff;
}

.lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}
.lds-ellipsis.green div {
    background: #2ed8b6;
}
.lds-ellipsis div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
}
@keyframes lds-ellipsis3 {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(0);
    }
}
@keyframes lds-ellipsis2 {
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(24px, 0);
    }
}

.v-step {
    background-color: #ffffff;
    color: #71717a;
    border: 1px solid #33333325;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.15);
    -webkit-box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.15);
}
.tour-btn {
    font-size: 0.9rem;
    padding: 0.3rem 0.6rem;
    border-radius: 5px;
}
.overlay-background {
    box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5);
}
.overlay {
    position: absolute;
    background-color: transparent;
    z-index: 9998;
    display: none;
    pointer-events: none;
    transition: all 0.3s ease;
    box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5);
    border-radius: 8px;
}
</style>
